/** @jsxImportSource @emotion/react */
import React from 'react'
import { useTheme } from '@material-ui/core/styles'
import Typography from '@purecarslabs/signal-components/Typography'
import { useLicenseInformationPopup } from '@purecarslabs/signal-containers/LicenseInformation/hooks'
import { getColorTextSelector } from '@purecarslabs/signal-theme/selectors'
import withCommonSnapshotsOnly from '@signal/hoc/withCommonSnapshotsOnly'
import withMounted from '@purecarslabs/signal-hoc/withMounted'
import { FooterDots, InnerWrapper, PrimaryLink, Wrapper } from './styles'
import isTest from '@purecarslabs/signal-utils/env/isTest'
import { useDarkModeContext } from '@signal/theme/Context/dark-mode'

const year = isTest() ? 2022 : new Date().getFullYear()

type AppFooterPropsType = {
  everNavigated?: boolean
  hideChrome?: boolean
  hideFooter?: boolean
  hideMenu?: boolean
  mounted?: boolean
}

const AppFooter: React.FC<AppFooterPropsType> = ({
  everNavigated,
  hideChrome,
  hideFooter,
  hideMenu,
  mounted,
  ...rest
}) => {
  const theme = useTheme()
  const { isDarkMode } = useDarkModeContext()
  const dotColor = isDarkMode
    ? 'rgba(0,0,0,0.3)'
    : getColorTextSelector()(theme)
  const { handleShowLicenseInformation } = useLicenseInformationPopup()

  if (hideChrome || hideFooter) {
    return <div />
  }

  return (
    <Wrapper
      id="appFooter"
      data-testid="appFooter"
      hideMenu={hideMenu}
      mounted={mounted || everNavigated}
      {...rest}
    >
      <FooterDots reversed dotColor={dotColor} />
      <InnerWrapper>
        <Typography variant="subtitle2">
          ©{year} PureCars Technologies. All rights reserved.
        </Typography>
        <Typography variant="subtitle2">
          <PrimaryLink
            href="https://www.purecars.com/privacy-policy/"
            target="_blank"
          >
            Privacy Policy
          </PrimaryLink>{' '}
          |{' '}
          <PrimaryLink
            href="https://www.purecars.com/terms-service-agreement/"
            target="_blank"
          >
            Terms &amp; Conditions
          </PrimaryLink>{' '}
          |{' '}
          <PrimaryLink onClick={handleShowLicenseInformation}>
            License Information
          </PrimaryLink>
        </Typography>
      </InnerWrapper>
    </Wrapper>
  )
}

export default withCommonSnapshotsOnly(withMounted(AppFooter))
